import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const housingUnitRoutes: RouteObject[] = [
  {
    path: '/housing-units',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Housing Units',
      crumb: () => ({ label: 'Housing Units', to: '/housing-units' }),
    },
  },
  {
    path: '/housing-units/view/:id',
    element: lazyElement(() => import('./DetailView')),
    handle: { crumb: () => ({ label: 'Housing Unit' }) },
  },
];

export default housingUnitRoutes;
